// src/modules/competitions/components/CompetitionCard.tsx - ESTILO AFICHE DE PELÍCULA

import React from 'react';
import { Competition } from '../types';
import { competitionService } from '../services/competitionService';
import '../styles/competitions.css';
// Al inicio del archivo
import { getFullImageUrl } from '../../../shared/services/apiConfig';

interface CompetitionCardProps {
  competition: Competition;
  onViewDetails: (id: number) => void;
  onRegister?: (id: number) => void;
  showActions?: boolean;
}

const CompetitionCard: React.FC<CompetitionCardProps> = ({
  competition,
  onViewDetails,
  onRegister,
  showActions = true
}) => {
  const registrationStatus = competitionService.isRegistrationOpen(competition);


  const hasPromotionalImage = (competition: Competition): boolean => {
    return !!competition.image_url;
  };

  const formatCurrency = (amount: number, currency: string) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: currency
    }).format(amount);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const handleCardClick = () => {
    onViewDetails(competition.id);
  };

  const handleRegisterClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onRegister && registrationStatus.isOpen) {
      onRegister(competition.id);
    }
  };

  return (
    <div className="competition-poster" onClick={handleCardClick}>
      {/* Imagen de fondo */}
      <div className="poster-background">
        {hasPromotionalImage(competition) ? (
          <img
            src={getFullImageUrl(competition.image_url) ?? undefined}
            alt={competition.title}
            className="poster-image"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const placeholder = e.currentTarget.parentElement?.querySelector('.poster-placeholder');
              if (placeholder) {
                (placeholder as HTMLElement).style.display = 'flex';
              }
            }}
          />
        ) : (
          <div className="poster-placeholder">
            🏆
          </div>
        )}
      </div>

      {/* Overlay con información (aparece en hover) */}
      <div className="poster-overlay">
        <div className="poster-content">
          <h3 className="poster-title">{competition.title}</h3>

          <div className="poster-info">
            <div className="poster-info-item">
              <span className="poster-icon">📅</span>
              <div className="poster-info-text">
                <span className="poster-label">Inicio</span>
                <span className="poster-value">{formatDate(competition.start_date)}</span>
              </div>
            </div>

            <div className="poster-info-item">
              <span className="poster-icon">💰</span>
              <div className="poster-info-text">
                <span className="poster-label">Precio</span>
                <span className="poster-value">
                  {competition.price > 0
                    ? formatCurrency(competition.price, competition.currency)
                    : 'Gratis'
                  }
                </span>
              </div>
            </div>
          </div>

          {showActions && (
            <div className="poster-actions">
              <button className="poster-btn poster-btn-primary" onClick={handleCardClick}>
                Ver detalles
              </button>

              {/* {onRegister && (
                <button 
                  className={`poster-btn ${registrationStatus.isOpen ? 'poster-btn-secondary' : 'poster-btn-disabled'}`}
                  onClick={handleRegisterClick}
                  disabled={!registrationStatus.isOpen}
                  title={registrationStatus.reason}
                >
                  {registrationStatus.isOpen ? 'Inscribirse' : 'No disponible'}
                </button>
              )} */}
            </div>
          )}
        </div>
      </div>

      {/* Badge de estado (siempre visible) */}
      <div className="poster-status-badge" data-status={competition.status}>
        {competition.status}
      </div>
    </div>
  );
};

export default CompetitionCard;